import Immutable from 'seamless-immutable';

import { actions } from './actions';

const defaultState = {
  loading: true,
  profile: {},
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.CLEAR: {
      return state.merge(defaultState);
    }
    case actions.LOAD_START: {
      return state.merge({
        loading: true,
      });
    }
    case actions.LOAD_SUCCESS: {
      const { profile } = action.payload;
      return state.merge({
        profile,
        loading: false,
      });
    }
    case actions.LOAD_FAIL: {
      const { error } = action.payload;
      return state.merge({
        error,
        loading: false,
      });
    }
    case actions.UPDATE_START: {
      return state.merge({
        loading: true,
      });
    }
    case actions.UPDATE_SUCCESS: {
      const { data } = action.payload;
      return state.merge({
        loading: false,
        profile: state.profile.merge(data),
      });
    }
    case actions.UPDATE_PASSWORD_SUCCESS: {
      return state.merge({
        loading: false,
      });
    }
    case actions.UPDATE_FAIL: {
      return state.merge({
        loading: false,
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/Profile/reducer.js